/**
 * Extrai a mensagem de erro de uma resposta de API JSON:API ou Axios.
 *
 * @param {unknown} error - Objeto de erro retornado pelo cliente jsonapi-react ou Axios.
 * @param {string} [fallback='Erro desconhecido'] - Mensagem usada quando nenhum detalhe é encontrado.
 * @returns {string} Mensagem legível.
 */
export function extractApiError(error, fallback = 'Erro desconhecido') {
  if (!error) return fallback;

  // JSON:API errors array
  if (Array.isArray(error?.errors)) {
    const first = error.errors[0];
    return first?.title || first?.detail || fallback;
  }

  // jsonapi-react desembrulha um array de erros JSON:API com um único item em
  // `{ error: {...} }` quando o objeto de erro não tem `status` (nosso backend nunca
  // envia esse campo), então aqui `error` já É o objeto de erro JSON:API (id/title/code).
  if (typeof error?.title === 'string') return error.title;
  if (typeof error?.detail === 'string') return error.detail;

  // Axios / fetch response body { error: '...' }
  if (typeof error?.error === 'string') return error.error;

  // Axios error.response.data
  if (typeof error?.response?.data?.errors?.[0]?.title === 'string') {
    return error.response.data.errors[0].title;
  }

  // Axios error.response.data.error (shape singular)
  const singular = error?.response?.data?.error;
  if (typeof singular === 'string' && singular.length) return singular;

  // Plain string
  if (typeof error === 'string') return error;

  return fallback;
}
